// typeguard
export const isISiteRemedy = (remedy) => {
    return (remedy.exceedsSiteFootprint !== undefined &&
        remedy.sumRemediesExceedsSiteFootprint !== undefined);
};
//# sourceMappingURL=mappedRemedy.js.map